import { render, staticRenderFns } from "./ResultSandbox.vue?vue&type=template&id=3152c335"
import script from "./ResultSandbox.vue?vue&type=script&lang=js"
export * from "./ResultSandbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports